import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ children, role }) {
    const { user, loading } = useAuth();
    const loc = useLocation();

    if (loading || user === null) {
        return (
            <div className="flex min-h-screen items-center justify-center bg-lightbg">
                <Loader2 className="h-8 w-8 animate-spin text-orange" />
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
    }
    if (role && user.role !== role) {
        const home = user.role === "admin" ? "/admin" : user.role === "professional" ? "/pro" : "/";
        return <Navigate to={home} replace />;
    }
    return children;
}
